// extracted by mini-css-extract-plugin
module.exports = {"imgNav":"Navbar_imgNav__3-jbq","navText":"Navbar_navText__E2LGC","navLogo":"Navbar_navLogo__3P6WQ","imgLogo":"Navbar_imgLogo__1Nib3"};